// imported in base router.ts
export default
	[{
		path: "/admin/",
		name: "admin",
		component: () => import("@/Views/Admin/Administration.vue"),
		props: false,
		meta: { name: "Administrator Functions", page: "admin" }
	}, {
		path: "/admin/find/",
		name: "findadmin",
		component: () => import("@/Views/Admin/FindAdmin.vue"),
		props: false,
		meta: { name: "Find Account", page: "admin" }
	}, {
		path: "/admin/streams/",
		name: "adminstreams",
		component: () => import("@/Views/Admin/AdminStreams.vue"),
		props: false,
		meta: { name: "All streams", page: "admin" }
		/*}, {
			path: "/admin/streampayments/",
			name: "adminstreampayments",
			component: () => import("@/Views/Admin/AdminStreamPayments.vue"),
			props: false,
			meta: { name: "Stream Payments", page: "admin" }*/
	},
	{
		path: "/admin/streamownerpayments/",
		name: "streamownerpayments",
		component: () => import("@/Views/Admin/AdminStreamOwnerPayments.vue"),
		props: false,
		meta: { name: "Stream Owner Payments", page: "admin" }
	},
	{
		path: "/admin/streamtailorpayments/",
		name: "streamtailorpayments",
		component: () => import("@/Views/Admin/AdminStreamTailorPayments.vue"),
		props: false
	},
	{
		path: "/admin/contentstreamadvanced/",
		name: "contentstreamadvanced",
		component: () => import("@/Views/Admin/AdminStreamAdvanced.vue"),
		props: false
	},
	/*{
		path: "/admin/streampaymentsactive/",
		name: "adminstreampaymentsactive",
		component: () => import("@/Views/Admin/AdminStreamPaymentsActive.vue"),
		props: false,
		meta: { name: "Stream Payments Active", page: "admin" }
	}, {
		path: "/admin/streampaymentsready/",
		name: "adminstreampaymentsready",
		component: () => import("@/Views/Admin/AdminStreamPaymentsReady.vue"),
		props: false,
		meta: { name: "Stream Payments Ready", page: "admin" }
	}, {
		path: "/admin/streampaymentscomplete/",
		name: "adminstreampaymentscomplete",
		component: () => import("@/Views/Admin/AdminStreamPaymentsComplete.vue"),
		props: false,
		meta: { name: "Stream Payments Complete", page: "admin" }
	}, */
	{
		path: "/admin/recentlyadded/",
		name: "recentlyadded",
		component: () => import("@/Views/Admin/RecentlyAddedArticles.vue"),
		props: false,
		meta: { name: "Recently added articles", page: "admin" }
	}, {
		path: "/admin/articles/",
		name: "adminarticles",
		component: () => import("@/Views/Admin/AllArticles.vue"),
		props: true,
		children: [],
		meta: { name: "All Articles", page: "admin" }
	}, {
		path: "/admin/recentconversion/",
		name: "recentconversion",
		component: () => import("@/Views/Admin/AdminRecentIssues.vue"),
		props: true,
		children: [],
		meta: { name: "Latest Conversions", page: "admin" }
	}, {
		path: "/admin/admintailoringtodo/",
		name: "admintailoringtodo",
		component: () => import("@/Views/Admin/ContentStreamAdminTodo.vue"),
		props: true,
		children: [],
		meta: { name: "Tailoring Required", page: "admin" }
	}];

